// extracted by mini-css-extract-plugin
module.exports = {"popover":"TagPopover_popover_EcEBv","list":"TagPopover_list_2Qu-t","checkbox":"TagPopover_checkbox_S3iVt"};